module.exports = __webpack_public_path__ + "img/cash.bf039800.png";